import { getDonaswapFlammiesAddress } from 'utils/addressHelpers'

export const nftsBaseUrl = '/nfts'
export const donaswapFlammiesAddress = getDonaswapFlammiesAddress()
